import React from 'react';

const SVGSuccessCheck = props => {
  return (
    <span className="svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
        <defs>
          <style>{'.check{fill:#fff;}'}</style>
        </defs>
        <title>Success</title>
        <circle className="cls-1" cx="7.5" cy="7.5" r="7.5" />
        <path
          className="check"
          d="M6.39,10.37A.48.48,0,0,1,6,10.21l-1.82-2a.48.48,0,0,1,0-.7.49.49,0,0,1,.7,0L6.39,9.13,9.53,5.6a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71L6.77,10.21A.64.64,0,0,1,6.39,10.37Z"
        />
      </svg>
    </span>
  );
};

export default SVGSuccessCheck;



// WEBPACK FOOTER //
// ./src/svg/SuccessCheck.js